module.exports = __webpack_public_path__ + "img/contact.f4d2be46.png";